module.exports = __webpack_public_path__ + "assets/img/example1.14f03376.jpg";